import { render, staticRenderFns } from "./StudentExamGoal.vue?vue&type=template&id=6befac88"
import script from "./StudentExamGoal.vue?vue&type=script&lang=js"
export * from "./StudentExamGoal.vue?vue&type=script&lang=js"
import style0 from "./StudentExamGoal.vue?vue&type=style&index=0&id=6befac88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports